import React, { useState } from "react";
import { Spinner } from "reactstrap";
import { toast } from "react-toastify";
import { createDeliverable } from "../../../api/casp/deliverable";
import { Button } from "reactstrap";
import { TextField } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import CloseIcon from '@mui/icons-material/Close';
import { withTranslation } from "react-i18next";
import SearchDropDownPaginationList from "../common/SearchDropDownPaginationList";
import { getAllPortfolios } from "../../../api/casp/portfolio";
import { Role } from "../../../constants/Common";
import { useSelector } from "react-redux";


function CreateDeliverable({
  // isOpen,
  setIsOpen,
  refresh,
  // emitProject,
  // projectCost,
  // projectStartDate,
  // projectEndDate,
  t
}) {
  // const [selectedProject, setSelectedProject] = useState("");
  // const { project } = useParams();
  const [deliverableCreationLoading, setDeliverableCreationLoading] = useState(false);
  const loggedInUser = useSelector((state) => state.Profile.user);
  const [deliverableObject, setDeliverableObject] = useState({
    name: "",
    // description: "",
    // projectId: project ? project : "",
    // expectedOutput: "",
    // cost: "",
    // weight: "",
    startDate: '',
    endDate: '',
    portfolios: {}
  });
  const deliverableValidation = Yup.object().shape({
    name: Yup.string()
      .strict(true)
      .trim(t('Must not include leading and trailing spaces'))
      .max(250, t("Too Long!"))
      .matches(/^(?=.*[a-zA-Z0-9])[a-zA-Z0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>/? ]*$/, t("Name should be in proper type"))
      .required(t("Please enter name")),
    // cost: Yup.number()
    //   .moreThan(0, t("Planned cost cannot be 0 or negative"))
    //   .max(projectCost, t(`Cost of Deliverable can not exceed the project cost ${projectCost}`))
    //   .required(t("Please Enter cost")),
    // weight: Yup.number()
    //   .min(0, t("Too Short!"))
    //   .max(100, t("Too Long!"))
    //   .required(t("Please Enter weight")),
    // startDate: Yup.date()
    //   .typeError(t("Given date is invalid type"))
    //   .required(t("Please Enter start date")),
    // .min(projectStartDate, `${t('Start date cannot be less than project start date')} ${dayjs(projectStartDate).format('MM/DD/YYYY')}`)
    // .max(projectEndDate, `${t('Start date cannot be greater than project end date')} ${dayjs(projectEndDate).format('MM/DD/YYYY')}`),
    // endDate: Yup.date()
    //   .typeError(t("Given date is invalid type"))
    //   .required(t("Please Enter end date")),
    // .max(projectEndDate, `${t('End date cannot be greater than project end date')} ${dayjs(projectEndDate).format('MM/DD/YYYY')}`)
    // .min(
    //   Yup.ref('startDate'),
    //   t("End date cannot be before Start date")
    // ),
    // portfolios: Yup.object().required(t("Please select cohort")),
    // projectId: Yup.number().required(t("Please select project")),
    // description: Yup.string()
    //   .max(2000, t("Description can not be greater than 2000 characters"))
    //   .strict(true)
    //   .trim(t('Must not include leading and trailing spaces'))
    //   .required(t("Please Enter description")),
    // expectedOutput: Yup.string()
    //   .strict(true)
    //   .trim(t('Must not include leading and trailing spaces'))
    //   .max(250, t("Too Long!"))
    //   .required(t("Please Enter expected output")),
  });

  const formik = useFormik({
    initialValues: {
      ...deliverableObject,
    },
    validationSchema: deliverableValidation,
    validateOnMount: true,
    onSubmit: (values) => {
      handleCreate();
    },
  });

  const toggleDrawer = () => {
    setIsOpen(false);
  };

  // const handleKeyDown = (event) => {

  //   if (event.keyCode === 8 || event.keyCode === 13) {
  //     return;
  //   }

  //   const regex = /^[0-9]+$/;

  //   if (!regex.test(event.key)) {
  //     event.preventDefault();
  //   }
  // }

  const handleCreate = async () => {
    try {
      setDeliverableCreationLoading(true);
      const response = await createDeliverable({
        // ...formik.values,
        name: formik.values.name,
        // startDate: formik.values.startDate,
        // endDate: formik.values.endDate,
        // portfolioId: formik.values.portfolios.id,
        // cost: parseFloat(formik.values.cost),
        // weight: parseInt(formik.values.weight),
        projectId: null,
        // projectId: parseInt(formik.values.projectId),
      });
      if (response.statusCode === 200) {
        toast.success(response.data.message);
        refresh()
        setDeliverableObject({});
        setIsOpen(false);
        setDeliverableCreationLoading(false);
        // emitProject(+new Date());
      } else {
        toast.error(response.data.message);
        setDeliverableCreationLoading(false);
      }
    } catch (err) {
      setDeliverableCreationLoading(false);
      toast.error(err?.message);
    }
  };

  // useEffect(() => {
  //   if (project) {
  //     setSelectedProject({ id: project });
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);
  return (
    <React.Fragment>
      {/* <ModalHeader className="border-bottom-0" toggle={toggle}> */}
      {/* </ModalHeader> */}
      <form className="p-3" onSubmit={formik.handleSubmit}>
        <h5>{t("Add Deliverable")}</h5>
        {/* <CloseIcon className="crossIcon" onClick={toggleDrawer("right", false)} /> */}
        <CloseIcon className="crossIcon" onClick={toggleDrawer} />
        {/* <ModalBody> */}
        <div className="innerTbContent">
          <div className="row">
            <div className="col-sm-12 mb-3">
              <TextField
                id="outlined-basic"
                label={t("Name")}
                variant="outlined"
                name="name"
                disabled={deliverableCreationLoading}
                value={formik.values.name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                fullWidth
                required
              />
              {formik.touched.name && formik.errors.name && (
                <span className="text-danger">{formik.errors.name}</span>
              )}
            </div>
            {/* <div className="col-sm-12 mb-3">
              <TextField
                fullWidth
                className="form-control"
                id="deliverable-title-input"
                label={t("Description")}
                name="description"
                value={formik.values.description}
                disabled={deliverableCreationLoading}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                multiline
                required
                rows={2}
              />
              {formik.touched.description && formik.errors.description && (
                <span className="text-danger">{formik.errors.description}</span>
              )}
            </div> */}
            {/* <div className="col-sm-12 mb-3">
              <TextField
                fullWidth
                className="form-control"
                id="deliverable-title-input"
                label={t("Expected Output")}
                name="expectedOutput"
                value={formik.values.expectedOutput}
                disabled={deliverableCreationLoading}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                multiline
                required
                rows={3}
              />
              {formik.touched.expectedOutput && formik.errors.expectedOutput && (
                <span className="text-danger">{formik.errors.expectedOutput}</span>
              )}
            </div>
            {!project && (
              <div className="col-sm-12 mb-3">
                <SearchDropDownListPaginationComponent
                  label={t("Startups") + ' *'}
                  searchEnabled={false}
                  onBlur={() => {
                    if (!formik.touched?.projectId) {
                      formik.setFieldTouched("projectId", true, true);
                    }
                  }}
                  listCall={getAllProject}
                  defaultValue={null}
                  emitItem={(newValue) => {
                    setSelectedProject(newValue);
                    formik.setFieldValue(
                      "projectId",
                      newValue ? newValue.id : ""
                    );
                  }}
                  apiParams={{
                    filterFields: ["status"],
                    filterInputs: [
                      `${ProjectStatuses.CONFIRMATION_REJECTED},${ProjectStatuses.ONGOING}`,
                    ],
                    order: "id",
                    direction: "asc",
                  }}
                />
                {formik.touched.projectId && formik.errors.projectId && (
                  <span className="text-danger">{formik.errors.projectId}</span>
                )}
              </div>
            )} */}
            {/* <div className="col-sm-6 mb-3 plCurrency currency_small_font">
              <TextField
                minimumValue="0"
                id="deliverable-cost"
                variant="outlined"
                // label='Deliverable Cost'
                decimalPlaces={2}
                value={formik.values.cost}
                // size="small"
                currencySymbol={t("SAR")}
                fullWidth
                placeholder={t("Deliverable Cost")}
                required
                disabled={deliverableCreationLoading}
                onChange={(e, newValue) => {
                  formik.setFieldValue('cost', newValue === 0 ? '' : newValue, true)
                }}
                onBlur={() => {
                  formik.setFieldTouched('cost', true, true)
                }}
              />
              {formik.touched.cost && formik.errors.cost && (
                <span className="text-danger">{formik.errors.cost}</span>
              )}
            </div> */}
            {/* <div className="col-sm-6 mb-3">
              <TextField
                onWheel={(e) => e.target.blur()}
                id="outlined-basic"
                label={t("Weight")}
                variant="outlined"
                onKeyDown={handleKeyDown}
                disabled={deliverableCreationLoading}
                name="weight"
                value={formik.values.weight}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                type="number"
                fullWidth
                required
              />
              {formik.touched.weight && formik.errors.weight && (
                <span className="text-danger">{formik.errors.weight}</span>
              )}
            </div> */}
            {/* <div className="col-sm-6 mb-3 plDatepicker"> */}
              {/* <FormControl fullWidth> */}
              {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker"]}>
                  <DatePicker
                    label={t("Start Date") + ' *'}
                    className="form-control"
                    disabled={deliverableCreationLoading}
                    format="MM/DD/YYYY"
                    name="startDate"
                    value={
                      formik?.values?.startDate?.toString().trim()
                        ? dayjs(formik.values.startDate)
                        : null
                    }
                    on
                    slotProps={{
                      field: {
                        clearable: true, onBlur: (_) => {
                          if (!formik.touched?.startDate) {
                            formik.setFieldTouched("startDate", true, false);
                          }
                        }
                      },
                      onClear: () => {
                        formik.setFieldValue("startDate", '');
                      },
                    }}
                    onChange={(e) => {
                      formik.setFieldValue(
                        "startDate",
                        e ? dayjs(e).format("YYYY-MM-DD") : ''
                      );
                      if (!formik.touched?.startDate) {
                        formik.setFieldTouched("startDate", true, false);
                      }
                    }}
                    required
                  />
                </DemoContainer>
              </LocalizationProvider>
              {/* </FormControl> */}
              {/* {formik.touched.startDate &&
                formik.errors.startDate && (
                  <span className="text-danger">
                    {formik.errors.startDate}
                  </span>
                )}
            </div>  */}
            {/* <div className="col-sm-6 mb-3 plDatepicker"> */}
              {/* <FormControl fullWidth> */}
              {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker"]}>
                  <DatePicker
                    sx={{ mb: 1 }}
                    label={t("End Date") + ' *'}
                    className="form-control"
                    disabled={deliverableCreationLoading}
                    format="MM/DD/YYYY"
                    name="endDate"
                    value={
                      formik?.values?.endDate?.toString().trim()
                        ? dayjs(formik.values.endDate)
                        : null
                    }
                    slotProps={{
                      field: {
                        clearable: true, onBlur: (_) => {
                          if (!formik.touched?.endDate) {
                            formik.setFieldTouched("endDate", true, false);
                          }
                        }
                      },
                      onClear: () => {
                        formik.setFieldValue("endDate", '');
                      },
                    }}
                    onChange={(e) => {
                      formik.setFieldValue(
                        "endDate",
                        e ? dayjs(e).format("YYYY-MM-DD") : ''
                      );
                      if (!formik.touched?.endDate) {
                        formik.setFieldTouched("endDate", true, false);
                      }
                    }}
                    required
                  />
                </DemoContainer>
              </LocalizationProvider> */}
              {/* </FormControl> */}
              {/* {formik.touched.endDate &&
                formik.errors.endDate && (
                  <span className="text-danger d-block">
                    {formik.errors.endDate}
                  </span>
                )}
            </div>  */}
            {/* <div className="mb-3 plSelectTypeField">
              <SearchDropDownPaginationList
                label={t("Cohort") + " *"}
                disabled={deliverableCreationLoading}
                searchEnabled={false}
                listCall={getAllPortfolios}
                disableClearable={!formik.values.portfolios}
                defaultValue={Object.keys(formik.values.portfolios).length !== 0 ? formik.values.portfolios : undefined}
                apiParams={{
                  order: "updatedAt",
                  direction: "desc",
                  ...(![
                    Role.PROJECT_MANAGER,
                    Role.EPMO_MANAGER,
                    Role.ROOT_ADMIN,
                    Role.VICE_PRESIDENT,
                    Role.PRESIDENT,
                    Role.PROGRAM_MANAGER,
                    Role.EPMO_OFFICER,
                  ].includes(loggedInUser?.role?.name) && {
                    filterFields: "portfolioUser",
                    filterInputs: loggedInUser.id,
                  }),
                }}
                emitItem={(newValue) => {
                  formik.setFieldTouched("portfolios", true, true);
                  formik.setFieldValue(
                    "portfolios",
                    newValue ? newValue : {}
                  );
                }}
                onBlur={() => {
                  if (!formik.touched?.portfolios) {
                    formik.setFieldTouched("portfolios", true, true);
                  }
                }}
              />
              {formik.touched.portfolios && formik.errors.portfolios && (
                <span className="text-danger">
                  {formik.errors.portfolios}
                </span>
              )}
            </div> */}
          </div>
        </div>
        {/* </ModalBody> */}
        <div className="plsubmitButton">
          <Button
            className="btn addNew_ProjectBtn"
            disabled={deliverableCreationLoading || !formik.isValid}
            type="submit"
          >
            {deliverableCreationLoading && (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                className="me-1"
              />
            )}
            <span className="visually-hidden">Loading...</span>
            {t("Submit")}
          </Button>
        </div>
      </form>
    </React.Fragment>
  );
}

export default withTranslation()(CreateDeliverable)